<template>
  <OutgoingReturnForm
    formTitle="Buat Retur Pemutihan"
    defaultDescription="Pemutihan"
  />
</template>

<script>
import OutgoingReturnForm from './OutgoingReturnForm.vue'
export default {
  components: { OutgoingReturnForm }
}
</script>
